import script from "./RoleSectionBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionBlock.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionBlock.vue?vue&type=style&index=0&id=d0a48c68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a48c68"]])

export default __exports__